<form [formGroup]="formGroup">
    <div [formGroupName]="groupName">
        <div *ngFor="let service of services; index as i" class="columns">
            <div class="column is-flex is-align-content-flex-start">
                <input [formControlName]="service.shortName" *ngIf="useCheckboxes; else radioInput" [attr.vservice-name]="service.shortName" [id]="categoryId + '_' + i" type="checkbox"
                       class="custom-checkbox">
                <ng-template #radioInput>
                    <input [formControlName]="groupName" [attr.vservice-name]="service.shortName" [id]="categoryId + '_' + i" type="radio"
                           class="custom-radio" [value]="service.shortName">
                </ng-template>

                <label [for]="categoryId + '_' + i">
                    <span class="is-bold has-text-grey-dark">
                        {{service.longName}}
                    </span>
                </label>
                <div class="ml-3" *ngIf="service.additionalInformation">
                    {{service.additionalInformation}}
                    <span *ngIf="this.digitizationServiceApproximatePricing[service.shortName]"
                          class="has-text-weight-bold is-lightblue">{{this.digitizationServiceApproximatePricing[service.shortName]}}</span>
                </div>
            </div>
            <div *ngIf="digitizationServiceApproximatePricing[service.shortName] && !service.additionalInformation" class="column">
                <span class="has-text-weight-bold is-lightblue">
                    {{digitizationServiceApproximatePricing[service.shortName]}}
                </span>
            </div>
        </div>
    </div>
</form>
